export class SetProjectsListScrollTop {
    static type = "[Projects] Set App projects list scroll top";

    constructor(public payload: number) {}
}
